import { render, staticRenderFns } from "./EmployerFundFormatPage.vue?vue&type=template&id=0c3182eb&"
import script from "./EmployerFundFormatPage.vue?vue&type=script&lang=ts&"
export * from "./EmployerFundFormatPage.vue?vue&type=script&lang=ts&"
import style0 from "./EmployerFundFormatPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports